import React from 'react';
import { observer } from "mobx-react-lite";
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from '../menu/MenuCardLabel';
import { useTranslation } from 'react-i18next';
import { BsBoxArrowInDownLeft } from 'react-icons/bs';
import styled from 'styled-components';
import { FaMinusCircle } from 'react-icons/fa';
import { undoableActionEditorSelectActionTreeHierachy } from '../../stores/undo/operation/ActionEditorSelectActionTreeHierarchy';
import { undoableActionEditorDeleteTemplate } from '../../stores/undo/operation/ActionEditorDeleteTemplateOp';
import { actionEditorStore } from '../../stores/ActionEditorStore';
import { sharedStore } from '../../stores/SharedStore';
import { gameStore } from '../../stores/GameStore';
const DeleteButton = styled.button.withConfig({
  displayName: "ActionTreeInfo__DeleteButton",
  componentId: "sc-z6i5ce-0"
})(["color:#DD0000;"]);
export const ActionTreeInfo = observer(() => {
  var _currentRootActionTre, _currentRootActionTre2;

  const {
    t
  } = useTranslation();
  const {
    currentActionTreeHierarchy,
    currentRootActionTree,
    treeFocussedForWorkshop
  } = actionEditorStore;
  const hierarchyNames = currentActionTreeHierarchy.map((subTreeNode, i) => {
    var _subTreeNode$treeProp;

    if (i > 0) return /*#__PURE__*/React.createElement("div", {
      key: i
    }, (_subTreeNode$treeProp = subTreeNode.treePropertiesAction) === null || _subTreeNode$treeProp === void 0 ? void 0 : _subTreeNode$treeProp.localizedName.get(gameStore.languageKey));
    return null;
  });

  const backToMainGameRootActionTree = () => {
    undoableActionEditorSelectActionTreeHierachy([sharedStore.mainGameRootActionTree.$modelId]);
  };

  const deleteTemplate = async () => {
    undoableActionEditorDeleteTemplate(currentRootActionTree);
  };

  const isMainGameRootOpen = currentRootActionTree === sharedStore.mainGameRootActionTree;
  return /*#__PURE__*/React.createElement(MenuCard, {
    minWidth: "200px",
    minHeight: "80px"
  }, /*#__PURE__*/React.createElement(MenuCardLabel, null, !isMainGameRootOpen && !treeFocussedForWorkshop && /*#__PURE__*/React.createElement(BsBoxArrowInDownLeft, {
    onClick: () => backToMainGameRootActionTree()
  }), isMainGameRootOpen || treeFocussedForWorkshop ? treeFocussedForWorkshop ? t("action_editor.tree_module") + ": " + ((_currentRootActionTre = currentRootActionTree.treePropertiesAction) === null || _currentRootActionTre === void 0 ? void 0 : _currentRootActionTre.localizedName.get(gameStore.languageKey)) : t("action_editor.tree_module") + ": " + t("action_editor.tree_module_main_game") : (_currentRootActionTre2 = currentRootActionTree.treePropertiesAction) === null || _currentRootActionTre2 === void 0 ? void 0 : _currentRootActionTre2.localizedName.get(gameStore.languageKey)), !(isMainGameRootOpen || treeFocussedForWorkshop) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: deleteTemplate
  }, /*#__PURE__*/React.createElement(FaMinusCircle, null), " ", t("action_editor.tree_delete_template"))), currentActionTreeHierarchy.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("action_editor.tree_hierarchy")), hierarchyNames));
});